module.exports = __webpack_public_path__ + "static/media/PC6-1.c8e5b975.jpg";